/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2023-03-02 17:53:42
 *
 *******************************************************/
//@flow

import _ from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { DisplayText } from '@shopify/polaris';
import { withI18n } from '@shopify/react-i18n';

type Props = {
  name: string,
  welcome: Object
};

type State = {
  width: number
};

class Welcome extends Component<Props, State> {
  state = { width: window.innerWidth };

  componentDidMount() {
    window.addEventListener('resize', this.resizeWindowEvent);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.resizeWindowEvent);
  }

  resizeWindowEvent = () => {
    this.setState({ width: window.innerWidth });
  };

  render() {
    const { name, i18n } = this.props;
    const { width } = this.state;

    return (
      <div className={`BC-Welcome__DashboardV3 ${width < 1000 ? 'small-screen' : ''}`}>
        <DisplayText size="large">
          {i18n.translate('AdminHTML.DashboardV3.Common.welcome', {
            name: name
          })}
        </DisplayText>
      </div>
    );
  }
}

const mapStateToProps = (state, props) => {
  const externalInfo = _.get(state.oauth.tenantApp, 'externalInfo', {});
  const welcome = _.get(state.dashboard, 'dashboardComponents.welcomes.data', {});

  return {
    name: _.get(externalInfo, 'name', ''),
    welcome
  };
};

const mapDispatchToProps = dispatch => ({});

export default withI18n()(connect(mapStateToProps, mapDispatchToProps)(Welcome));
